//api

import axios from "axios";

const getApiUrl = () => {
    const hostname = window.location.hostname;
    if (hostname.includes("localhost")) {
        return "http://dircas-backend.test.di.dgi.loc/wp-json/wp/v2";
    } else if (hostname.includes("test")) {
        return "http://dircas-backend.test.di.dgi.loc/wp-json/wp/v2";
    } else{
        return "https://dircas-backend.cloud.irrigacion.gov.ar/wp-json/wp/v2";
    }
};


const API_URL = getApiUrl();

const API_URL_DGI = "https://www.irrigacion.gov.ar/web/wp-json/wp/v2";

export const getPosts = async () => {
    try {
        //const response = await axios.get(`${API_URL}/posts`);
        const response = await fetch(`${API_URL_DGI}/posts?_embed`);
        return response.json();
        //return response.data;
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};

export const getPostById = async (id) => {
    try {
        const response = await axios.get(`${API_URL_DGI}/posts/${id}?_embed`);
        return response.data;
    } catch (error) {
        console.error("Error fetching post:", error);
        return null;
    }
};

export const getCampana = async () => {
    try {
        const response = await fetch(`${API_URL}/campana_agua`);
        return response.json();
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};

export const getAutoridades = async (params = {}) => {
    try {
        const query = new URLSearchParams({
            _embed: "",
            ...params,
        }).toString();

        const response = await fetch(`${API_URL_DGI}/oxy_staff?_embed&${query}`);
        return response.json();
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};
export const getAudiencia = async () => {
    try {
        const response = await fetch(`${API_URL}/audiencia_publica?_embed`);
        return response.json();
        //return response;
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};

export const getSistemaTarifario = async () => {
    try {
        const response = await fetch(`${API_URL}/sistema-tarifario?_embed`);
        return response.json();
        //return response;
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};

export const getInformacionPublica = async () => {
    try {
        const response = await fetch(`${API_URL}/informacion-publica`);
        return response.json();
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};

export const getOperadores = async () => {
    try {
        const response = await fetch(`${API_URL}/operadores`);
        return response.json();
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};

export const getPermisosPerforacion = async () => {
    try {
        const response = await fetch(`${API_URL}/permiso-perforacion?_embed`);
        return response.json();
        //return response;
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};
export const getObras = async () => {
    try {
        const response = await fetch(`${API_URL}/obras?_embed`);
        return response.json();
        //return response;
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};
export const getSolicitud = async () => {
    try {
        const response = await fetch(`${API_URL}/solicitud?_embed`);
        return response.json();
        //return response;
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};

export const getUrlReglamento = async () => {
    try {
        const response = await fetch(`${API_URL}/reglamento?_embed`);
        console.log("response", response);
        return response.json();
        //return response;
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};

export const getResRegulatorias = async () => {
    try {
        const response = await fetch(`${API_URL}/resolucion_regulator`);
        return response.json();
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};

export const getMultasRegulatorias = async () => {
    try {
        const response = await fetch(`${API_URL}/multa?_embed`);
        return response.json();
        //return response;
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};

export const getMarcoLegal = async () => {
    try {
        const response = await fetch(`${API_URL}/marco-regulatorio?_embed`);
        return response.json();
        //return response;
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};

export const getReclamos = async () => {
    try {
        const response = await fetch(`${API_URL}/reclamos?_embed`);
        return response.json();
        //return response;
    } catch (error) {
        console.error("Error fetching posts:", error);
        return [];
    }
};